"use strict";
/**
 * The three concepts the outline's "user roles" table conflated, kept apart.
 *
 * The outline lists `Premium Teacher` as a role. That single row is three
 * independent facts — what you do, where you do it, and what you paid for —
 * and modelling it as one enum explodes: `Premium Teacher`, `Free Teacher`,
 * `Premium Trainer`, `School Premium Teacher`… Splitting them is what keeps the
 * catalog at nine roles instead of nine times four.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORG_KIND_LABELS = exports.ORG_KINDS = exports.DEFAULT_ROLES = exports.PERSONA_LABELS = exports.PERSONAS = void 0;
/**
 * PERSONA — what the user says they are.
 *
 * Self-selected at signup, changeable from settings at any time, and it grants
 * nothing at all. It drives dashboard layout and recommendations, which is
 * exactly what "select their respective role (changeable downstream)" in the
 * outline is asking for: the thing a user may change about themselves must be
 * the thing that carries no authority.
 */
exports.PERSONAS = [
    'teacher',
    'teacher_trainer',
    'school_leader',
    'student',
    'curriculum_officer',
    'partner_admin',
];
exports.PERSONA_LABELS = {
    teacher: 'Teacher',
    teacher_trainer: 'Teacher Trainer',
    school_leader: 'School Leader',
    student: 'Student / Learner',
    curriculum_officer: 'Curriculum Support Officer',
    partner_admin: 'Ministry / NGO / Partner Administrator',
};
/**
 * ROLE — what an organisation has granted you inside it.
 *
 * Roles are rows in `org_roles`, so a tenant may invent its own; these are the
 * ones seeded into every new org. The names are privileged only because of the
 * grants attached to them, never because of the string — a tenant that creates
 * a role called `OWNER` gets a role with no grants, which is correct.
 */
exports.DEFAULT_ROLES = [
    'OWNER',
    'ORG_ADMIN',
    'SCHOOL_ADMIN',
    'FACILITATOR',
    'CONTENT_DEVELOPER',
    'TEACHER',
    'LEARNER',
    'ANALYST',
    'VIEWER',
];
/**
 * ORG KIND — where in the tenancy tree an organisation sits.
 *
 * `personal` is the one that makes the rest of the codebase simple: every user
 * gets one at signup, so a solo teacher and a ministry are the same code path
 * and no query ever needs a null-org branch.
 */
exports.ORG_KINDS = [
    'ministry',
    'county',
    'school',
    'ttc',
    'university',
    'ngo',
    'personal',
];
exports.ORG_KIND_LABELS = {
    ministry: 'Ministry of Education',
    county: 'County / Region',
    school: 'School',
    ttc: 'Teacher Training College',
    university: 'University',
    ngo: 'NGO / Development Partner',
    personal: 'Personal workspace',
};
//# sourceMappingURL=identity.js.map